import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import checkout from './checkout'
/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::invite
* @see app/Http/Controllers/Creator/TeamInvitationController.php:63
* @route '/app/creator/team/invite'
*/
export const invite = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: invite.url(options),
    method: 'post',
})

invite.definition = {
    methods: ["post"],
    url: '/app/creator/team/invite',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::invite
* @see app/Http/Controllers/Creator/TeamInvitationController.php:63
* @route '/app/creator/team/invite'
*/
invite.url = (options?: RouteQueryOptions) => {
    return invite.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::invite
* @see app/Http/Controllers/Creator/TeamInvitationController.php:63
* @route '/app/creator/team/invite'
*/
invite.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: invite.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::invite
* @see app/Http/Controllers/Creator/TeamInvitationController.php:63
* @route '/app/creator/team/invite'
*/
const inviteForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: invite.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::invite
* @see app/Http/Controllers/Creator/TeamInvitationController.php:63
* @route '/app/creator/team/invite'
*/
inviteForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: invite.url(options),
    method: 'post',
})

invite.form = inviteForm

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::destroy
* @see app/Http/Controllers/Creator/TeamInvitationController.php:175
* @route '/app/creator/team/invitations/{invitation}'
*/
export const destroy = (args: { invitation: number | { id: number } } | [invitation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/team/invitations/{invitation}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::destroy
* @see app/Http/Controllers/Creator/TeamInvitationController.php:175
* @route '/app/creator/team/invitations/{invitation}'
*/
destroy.url = (args: { invitation: number | { id: number } } | [invitation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invitation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invitation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invitation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invitation: typeof args.invitation === 'object'
        ? args.invitation.id
        : args.invitation,
    }

    return destroy.definition.url
            .replace('{invitation}', parsedArgs.invitation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::destroy
* @see app/Http/Controllers/Creator/TeamInvitationController.php:175
* @route '/app/creator/team/invitations/{invitation}'
*/
destroy.delete = (args: { invitation: number | { id: number } } | [invitation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::destroy
* @see app/Http/Controllers/Creator/TeamInvitationController.php:175
* @route '/app/creator/team/invitations/{invitation}'
*/
const destroyForm = (args: { invitation: number | { id: number } } | [invitation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::destroy
* @see app/Http/Controllers/Creator/TeamInvitationController.php:175
* @route '/app/creator/team/invitations/{invitation}'
*/
destroyForm.delete = (args: { invitation: number | { id: number } } | [invitation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::suspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:197
* @route '/app/creator/team/members/{user}/suspend'
*/
export const suspend = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: suspend.url(args, options),
    method: 'post',
})

suspend.definition = {
    methods: ["post"],
    url: '/app/creator/team/members/{user}/suspend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::suspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:197
* @route '/app/creator/team/members/{user}/suspend'
*/
suspend.url = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return suspend.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::suspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:197
* @route '/app/creator/team/members/{user}/suspend'
*/
suspend.post = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: suspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::suspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:197
* @route '/app/creator/team/members/{user}/suspend'
*/
const suspendForm = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: suspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::suspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:197
* @route '/app/creator/team/members/{user}/suspend'
*/
suspendForm.post = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: suspend.url(args, options),
    method: 'post',
})

suspend.form = suspendForm

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::unsuspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:216
* @route '/app/creator/team/members/{user}/unsuspend'
*/
export const unsuspend = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unsuspend.url(args, options),
    method: 'post',
})

unsuspend.definition = {
    methods: ["post"],
    url: '/app/creator/team/members/{user}/unsuspend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::unsuspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:216
* @route '/app/creator/team/members/{user}/unsuspend'
*/
unsuspend.url = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return unsuspend.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::unsuspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:216
* @route '/app/creator/team/members/{user}/unsuspend'
*/
unsuspend.post = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unsuspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::unsuspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:216
* @route '/app/creator/team/members/{user}/unsuspend'
*/
const unsuspendForm = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsuspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::unsuspend
* @see app/Http/Controllers/Creator/TeamInvitationController.php:216
* @route '/app/creator/team/members/{user}/unsuspend'
*/
unsuspendForm.post = (args: { user: number | { id: number } } | [user: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsuspend.url(args, options),
    method: 'post',
})

unsuspend.form = unsuspendForm

const team = {
    invite: Object.assign(invite, invite),
    checkout: Object.assign(checkout, checkout),
    destroy: Object.assign(destroy, destroy),
    suspend: Object.assign(suspend, suspend),
    unsuspend: Object.assign(unsuspend, unsuspend),
}

export default team